module.exports = __webpack_public_path__ + "static/media/wide.6170d57b.jpg";